import { render, staticRenderFns } from "./SignaturesList.vue?vue&type=template&id=ae4e5658&scoped=true&"
import script from "./SignaturesList.vue?vue&type=script&lang=js&"
export * from "./SignaturesList.vue?vue&type=script&lang=js&"
import style0 from "./SignaturesList.vue?vue&type=style&index=0&id=ae4e5658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4e5658",
  null
  
)

export default component.exports